import { render, staticRenderFns } from "./inputTextDescription.pug?vue&type=template&id=cb668a36&lang=pug&"
import script from "./inputTextDescription.js?vue&type=script&lang=js&"
export * from "./inputTextDescription.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb668a36')) {
      api.createRecord('cb668a36', component.options)
    } else {
      api.reload('cb668a36', component.options)
    }
    module.hot.accept("./inputTextDescription.pug?vue&type=template&id=cb668a36&lang=pug&", function () {
      api.rerender('cb668a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/textDescription/index.vue"
export default component.exports